
import { Outlet } from "react-router-dom";
import bubbleBackgroung from "../../assets/webp/bubbleBackgroung.webp";

export default function SignUpOnboarding() {
  return (
    <div className=" h-[calc(100vh-83px)]" >
      <section
        id="home"
        className="relative w-full h-[calc(100vh-83px)] bg-no-repeat bg-cover bg-top"
        style={{ backgroundImage: `url(${bubbleBackgroung})` }}
      >
        <div className="relative z-20 w-full flex justify-center items-center h-full mx-auto gap-10">
             <Outlet />
        </div>
      </section>
    </div>
  );
}
